<script>
import Editor from '@tinymce/tinymce-vue'

// Require the css for the editor. Note that we do not load this CSS directly on
// this page. The nature of TinyMCE is that it is loaded into an iFrame and the
// editor sets html body css and such (we don't want that on our whole page).
// The webpack config has been modified to copy any tinymce css files directly
// to dist rather than include them on this page.
require('tinymce/skins/ui/oxide/skin.min.css')
require('tinymce/skins/ui/oxide/content.min.css')
require('tinymce/skins/content/default/content.min.css')

export default {
  name: 'RichTextEditor',
  extends: Editor,
  props: {
    init: {
      type: Object,
      default: function () {
        return {
          // Skin and content CSS are loaded via web-pack (see note above)
          content_css: '/node_modules/tinymce/skins/content/default/content.min.css',
          skin_url: '/node_modules/tinymce/skins/ui/oxide/',
          branding: false,
          menubar: 'file edit view format',
          font_name: 'Arial',
          toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link',
          plugins: 'advlist autolink lists link charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste'
        }
      }
    }
  },
  methods: {
    beforeCreate () {
      // Initialize TinyMCE
      this.$tinymce.init()
    }
  }
}
</script>
